import { UserHelper } from "@/helpers/user.helper";
import { NgIf } from "@angular/common";
import { Component, OnInit } from "@angular/core";
import {
  AnalyticsService,
  KpiRealtorContact,
  KpiRealtorProperty,
  KpiRealtorPropertyShare,
} from "@eemo/api-client";
import { KpiComponent } from "../kpi/kpi.component";

@Component({
  selector: "app-analytics-realtors",
  templateUrl: "./analytics-realtors.component.html",
  styleUrls: ["./analytics-realtors.component.scss"],
  standalone: true,
  imports: [NgIf, KpiComponent],
})
export class AnalyticsRealtorsComponent implements OnInit {
  kpiRealtorProperty: KpiRealtorProperty;
  kpiRealtorShare: KpiRealtorPropertyShare;
  kpiRealtorContact: KpiRealtorContact;

  cardClass = "col-12 col-sm-6 col-md-4 col-xl-3 mb-3";

  constructor(
    private analyticsService: AnalyticsService,
    private userHelper: UserHelper
  ) {}

  ngOnInit() {
    const userId = this.userHelper.currentUser.userId;
    this.analyticsService
      .getKpiRealtorProperties(userId)
      .subscribe((kpi) => (this.kpiRealtorProperty = kpi));
    this.analyticsService
      .getKpiRealtorShares(userId)
      .subscribe((kpi) => (this.kpiRealtorShare = kpi));
    this.analyticsService
      .getKpiRealtorContacts(userId)
      .subscribe((kpi) => (this.kpiRealtorContact = kpi));
  }
}
